<div class="info-strip" [ngClass]="class">
  <mat-icon svgIcon="info-icon"></mat-icon>
  <p [innerHTML]="message"></p>
  <ng-content></ng-content>
</div>
